<script>
import { mapGetters } from 'vuex'
import NewsCard from "@components/common/news-card.vue";

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    NewsCard,
  },
  mixins: [
    Translatable
  ],
  computed: {
    ...mapGetters('currentNews', [
      'homeNewsList'
    ]),
  }
}
</script>

<template>
  <div class="section-container">
    <div class="content">
      <NewsCard v-for="news in homeNewsList" :key="news._id" :news="news"/>
    </div>
    <div class="container">
      <router-link
        :to="{
          name: 'news',
          params: {
            type: 'whats-on',
          },
        }"
        class="button-container"
      >
        <button class="button">{{ getTranslatedContent('SEE_ALL_NEWS') }}</button>
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  display: grid;
  justify-items: center;
  row-gap: 65px;
  grid-template-columns: repeat(1, 1fr);
}

.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  text-decoration: none;
}

.button {
  min-width: 228px;
  height: 48px;
  padding: 0 20px;
  background: $orange;
  border-radius: 5px;
  border: 1px solid $orange;
  text-transform: uppercase;
  font-family: Open Sans Bold, sans-serif; // temp-text
  font-weight: bold;
  // font-family: Open Sans, sans-serif;
  // font-weight: normal;
  font-style: normal;
  font-size: 15px;
  line-height: 19px;
  color: $white;

  &:hover {
    border: 1px solid $hover-orange;
    background: $hover-orange;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {

  .button-container {
    margin-top: 15px;
    .button  {
      width: 100%;
    }
  }

  .content {
    row-gap: 30px;
    margin-top: 20px;
  }
}
</style>
